import axios from '../../services/axios.service';
import { getEndpointBase } from '../../services/api.service';
import { SourceFetchParams, SourceSort } from './Source.type';

let listRequest: any = null;

const sourceService = {
  getList: ({ q, page, sort = SourceSort.ALPHA_LINKED, ...params }: SourceFetchParams) => {
    listRequest && listRequest.cancel();
    listRequest = axios.CancelToken.source();
    return axios.get(getEndpointBase(`sources`), {
      cancelToken: listRequest.token,
      params: {
        q,
        sort,
        page,
        filter: {
          ...params,
        },
      },
    });
  },
};

export default sourceService;
